import { DeployCountry } from "@types";

/**
 * Phone config (local-only rules)
 * - startWith: Allowed starting masks for local numbers. Supports wildcards: '*' matches a digit.
 * - additionalLengths: Additional local total-digit lengths (legacy multi-length only, e.g., +62)
 * - simpleError: Simplify validator messages to "Enter a {{length}} digit number" when single-length
 * - noLeadingZero: If true, member settings will NOT add +1 to server lengths
 */
type PhoneConfig = {
  startWith: string[];
  additionalLengths?: number[];
  simpleError?: boolean;
  noLeadingZero?: boolean;
  displayInputPrefix?: boolean;
};

export const COUNTRY_CODE = {
  [DeployCountry.ID]: "+62",
  [DeployCountry.IN]: "+91",
  [DeployCountry.MX]: "+52",
  [DeployCountry.BR]: "+55",
  [DeployCountry.TH]: "+66",
  [DeployCountry.PH]: "+63",
  [DeployCountry.PE]: "+51",
  [DeployCountry.EG]: "+20",
  [DeployCountry.CO]: "+57",
} as const;

export const PHONE_CONFIGS: Record<string, PhoneConfig> = {
  // Indonesia (legacy local starts with 0)
  ["+62"]: {
    startWith: ["0"],
    additionalLengths: [10], // old format, BE didn't send old length
  },
  // India (INR) no leading zero required
  ["+91"]: {
    startWith: [],
    simpleError: true,
    noLeadingZero: true,
    displayInputPrefix: true,
  },
  // Mexico (MXN) no leading zero required
  ["+52"]: {
    startWith: [],
    simpleError: true,
    noLeadingZero: true,
    displayInputPrefix: true,
  },
  // Brazil (BRL) no leading zero required
  ["+55"]: {
    startWith: [],
    simpleError: true,
    noLeadingZero: true,
    displayInputPrefix: true,
  },
  // Peru (PEN) no leading zero required
  ["+51"]: {
    startWith: [],
    simpleError: false,
    noLeadingZero: true,
    displayInputPrefix: true,
  },
  // Egypt (EGP) local starts with 0
  ["+20"]: {
    startWith: ["0"],
  },
  // Colombia (COP) no leading zero required
  ["+57"]: {
    startWith: [],
    simpleError: true,
    noLeadingZero: true,
    displayInputPrefix: true,
  },
} as const;

// Other countries required 0
export const DEFAULT_PHONE_CONFIG: PhoneConfig = {
  startWith: ["0"],
} as const;
